module.exports = __webpack_public_path__ + "img/KZ.09c40dc4.svg";